import { ListSubheader as UiListSubHeader, styled } from "@l2r-front/l2r-ui"

export const ListSubHeader = styled(UiListSubHeader)(({ theme, variant }) => ({
    fontSize: theme.typography[variant].fontSize,
    fontWeight: theme.typography[variant].fontWeight,
}))